export function buildTree(nodes: Hierarchy.IHierarchyItem[]): Hierarchy.IHierarchyItem[] {
    let items: Hierarchy.IHierarchyItem[] = [];
    let added = {};
    let children = {};

    let adder = (asset: Hierarchy.IHierarchyItem, child: Hierarchy.IHierarchyItem) => {
        if (!asset || asset.level < 1) {
            return;
        }

        let copy: Hierarchy.IHierarchyItem = added[asset.id];

        if (!copy) {
            copy = { ...asset };
            copy.children = [];

            added[copy.id] = copy;

            if (copy.level === 1) {
                items.push(copy);
            }
        }

        if (child && !children[child.id]) {
            child.parent = copy;
            copy.children.push(child);
            children[child.id] = true;
        }

        adder(copy.parent, copy);
    };
         
    nodes.forEach((asset: Hierarchy.IHierarchyItem) => {
        adder(asset, null);
    });

    return items;
}
